import * as React from "react";

const SvgBan = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M18.364 18.364A9 9 0 0 0 5.636 5.636" />
      <path d="M18.364 18.364A9 9 0 0 1 5.636 5.636M18.364 18.364 5.636 5.636" />
    </g>
  </svg>
);

export default SvgBan;
